import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store, select } from '@ngrx/store';
import { AppState } from '../store';
import { selectTenantInfo } from '../store/selectors';
import { checkIfPlatformSite } from '../common/platform-utils';

/**
 * Resolves which designs to render. The redesigns are the default for every
 * tenant; a school owner can roll back via Admin => Settings => Navigation
 * (useClassicHeaderFooter / useClassicSalesPage). The platform site always
 * stays classic.
 */
@Injectable({ providedIn: 'root' })
export class RevampDesignService {
  private readonly store = inject<Store<AppState>>(Store);

  private readonly isPlatformSite = checkIfPlatformSite();

  private readonly tenantSig = toSignal(this.store.pipe(select(selectTenantInfo)));

  readonly useNewDesign = computed(() => !this.isPlatformSite && !this.tenantSig()?.useClassicHeaderFooter);

  readonly useNewSalesPage = computed(() => !this.isPlatformSite && !this.tenantSig()?.useClassicSalesPage);

  /**
   * Opt-IN, unlike its two siblings above: the new builder is served only when a tenant has
   * explicitly turned the classic one off.
   *
   * NOTE for whoever flips this: `undefined` and `true` both mean classic here, so the check is
   * `=== false`, not `!value`.
   */
  readonly useNewCourseBuilder = computed(() =>
    !this.isPlatformSite && this.tenantSig()?.useClassicCourseBuilder === false);
}
